/**
 * 微信服务号，游客访问入口界面，这个界面的功能无需登录
 */
import React from 'react';

import { Carousel } from 'antd-mobile';


import http from "../../../axios/wechatHttp";


import server from "../../../axios/server";

//布局样式
import './accessIndex.css';
//图标库
// import '../../../style/common/icon.css';

class AccessIndex extends React.Component {

    state = {
        carouselList: [], //轮播图信息
    }

    componentDidMount() {
        this.loadCarousel();
    }

    loadCarousel = () => {
        http.post({
            url: '/findWxCarousel',
            data: {
                carouselType: 3
            },
            success: (res) => {
                if (res != null && res.length > 0) {
                    res.forEach((e) => {
                        e.image = encodeURI(server.httpServerUrl + "/common/image?imagePath=" + e.image);
                    });
                } else {
                    res = [];
                }
                this.setState({ carouselList: res });
            }
        });
    }

    render() {
        const { carouselList } = this.state;
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <div className="layout-header">
                    <Carousel className="layout-carousel"
                        autoplay={true}
                        infinite={true}
                        autoplayInterval={5000}
                        dots={true}
                        dragging={true}
                    >
                        {carouselList.map((item, index) => {
                            return (<div className="carousel-item">
                                <img className="carousel-image" src={item.image} alt=""></img>
                            </div>);
                        })}
                    </Carousel>
                </div>
                <div className="layout-center">
                    <div className="layout-menu">
                        <div className="menu-button">
                            <span className="iconfont icon-finance-review"></span>
                            <div>财务审核</div>
                        </div>
                        <div className="menu-button">
                            <span className="iconfont icon-user"></span>
                            <div>个人信息</div>
                        </div>
                    </div>
                </div>
                <div className="layout-footer">
                    <div className="footer-log"></div>
                    <div>地址：福建省厦门市湖里区枋湖路8号</div>
                    <div>咨询热线：0592-5165566</div>
                </div>
            </div>
        )
    }
}

export default AccessIndex;